<template lang="pug">
  #program-questions
    BTabs.px-5.custom-tabs(
      v-model="activeTab"
      size="is-medium"
    )
      BTabItem(
        :key="0"
        label="Active"
      )
        WtEntityTable#questions-table(
          title=''
          has-large-title
          :data="activeQuestions"
          defaultSortField="order"
          defaultSortDirection="asc"
          empty-message="No questions found..."
          :showEmptyMessage="true"
          :enableSearch="false"
        )
          BTableColumn(
            field="order"
            sortable
            v-slot="column"
            :visible="false"
          ) {{ column.row.isWellnessChallenge ? 0 : column.row.order }}
          BTableColumn(
            label="Order"
            v-slot="column"
            :width="160"
            :headerSelectable="false"
          )
            template(v-if="column.row.isWellnessChallenge")
              RouterLink.has-text-teal(
                :to="{ name: 'Challenge', params: { challengeId: column.row.challengeId } }"
              ) Wellness Challenge Question
            template(v-else)
              WtButton.post-button(
                color="primary"
                :isRouterLink="false"
                :isText="true"
                :disabled="processing"
                @click.native="updateQuestionOrder(column.row, +1)"
              )
                BIcon(icon="chevron-down" size="is-medium")

              WtButton.post-button(
                color="primary"
                :isRouterLink="false"
                :isText="true"
                :disabled="processing"
                @click.native="updateQuestionOrder(column.row, -1)"
              )
                BIcon(icon="chevron-up" size="is-medium")
          BTableColumn(
            field="question"
            label="Question"
            v-slot="column"
          )
            .is-flex.is-flex-direction-column
              .is-flex
                span {{ column.row.question }}
                span.pl-1(v-if="column.row.startDate && column.row.endDate")
                  BTooltip(
                    label=""
                    position="is-bottom"
                    multilined
                    animated
                  )
                    template(slot="content")
                      span Shows on {{ date(column.row.startDate, 'DATE_FORMAT_FULL_MONTH').formatted }}
                      span , disappears on {{ date(column.row.endDate, 'DATE_FORMAT_FULL_MONTH').formatted }}
                    BIcon(icon="calendar")
                span
                  BTag.points-tag(
                    v-if="column.row.pointValue"
                  ) {{column.row.pointValue}} pts
              QuestionViewAnswers(:type="column.row.type" :answers="column.row.fields" :correctAnswer="column.row.correctAnswer")
          BTableColumn(
            field="required"
            label="Required"
            v-slot="column"
            :width="160"
            :centered="true"
          )
            template(v-if="column.row.isWellnessChallenge")
              BTooltip(
                label="Wellness Challenge questions are always optional."
                position="is-bottom"
                multilined
                animated
              )
                BCheckbox.margin-column-field(
                  size="is-medium"
                  :value="false"
                  :disabled="true"
                )
            template(v-else)
              BCheckbox.margin-column-field(
                size="is-medium"
                :value="column.row.required"
                :disabled="processing"
                @input="(newValue) => updateQuestionRequired(newValue, column.row)"
              )
          //BTableColumn(
          //    label="Responses"
          //    v-slot="column"
          //    :width="100"
          //    :centered="true"
          //)
            span.is-block.margin-column-field.has-text-grey 0
          BTableColumn(
            label=""
            v-slot="column"
            :width="160"
            :headerSelectable="false"
          )
            template(v-if="column.row.category.includes('wellness')")
              BTooltip(
                label="Wellness Challenge Questions cannot be removed."
                position="is-bottom"
                multilined
                animated
              )
                .has-text-grey Remove
            template(v-else)
              .is-flex
                WtButton.post-button(
                  semibold
                  color="primary"
                  :isRouterLink="false"
                  :isText="true"
                  :disabled="processing"
                  :loading="questionIdBeingProcessed === column.row.id"
                  @click.native="editQuestion(column.row)"
                ) Edit
                WtButton.post-button(
                  v-if="isProTier"
                  semibold
                  color="grey"
                  :isRouterLink="false"
                  :isText="true"
                  :disabled="processing"
                  :loading="questionIdBeingProcessed === column.row.id"
                  @click.native="toggleQuestionArchivedStatus(column.row)"
                ) Archive
                WtButton.post-button(
                  semibold
                  :isRouterLink="false"
                  :isText="true"
                  color="grey"
                  :disabled="processing"
                  :loading="questionIdBeingProcessed === column.row.id"
                  @click.native="deleteQuestion(column.row.id)"
                ) Delete

        //.remove-all-questions-button
        //  WtButton(
        //    bold
        //    color="grey"
        //    size="medium"
        //    outlined
        //    :isRouterLink="false"
        //    :disabled="!activeQuestions.length || processing"
        //    :loading="removingActiveQuestions"
        //    @click.native="removeAllActiveQuestions"
        //  ) Remove all Active Questions
          //WtButton(
          //  bold
          //  color="primary"
          //  size="medium"
          //  :isRouterLink="false"
          //  :disabled="!questionsForUpdateInActive.length || processing"
          //  :loading="savingActiveQuestions"
          //  @click.native="saveQuestions('active')"
          //) SAVE
        hr
        WtTile(v-if="$auth.user().isAdmin" :col="12")
          WtTile(parent :col="6" vertical)
            WtButton(
              @click.native="toggleQuestionModal(true)"
            ) CREATE A NEW QUESTION
          WtTile(parent :col="6" vertical)
            WtTitle(h4) Draft Questions
              .block(class="mt-3" v-if="programQuestionsLoaded")
                QuestionViewAdminSuper(
                  :data="item"
                  :key="item.id"
                  v-for="item in draftQuestions"
                )
                .has-text-centered.is-size-6(v-if="!draftQuestions.length")
                  span.has-text-grey No questions...
      BTabItem(
        v-if="isProTier"
        :key="1"
        label="Archived"
      )
        WtEntityTable#questions-table(
          title=''
          has-large-title
          :data="archivedQuestions"
          default-sort-field="question"
          empty-message="No questions found..."
          :showEmptyMessage="true"
          :enableSearch="true"
          :searchFields="['question']"
          searchPlaceholder="Search the archive library..."
        )
          BTableColumn(
            field="question"
            label="Question"
            sortable
            v-slot="column"
          )
            .is-flex.is-flex-direction-column
              span {{ column.row.question }}
              QuestionViewAnswers(:type="column.row.type" :answers="column.row.fields" :correctAnswer="column.row.correctAnswer")
          BTableColumn(
            field="active"
            label=""
            v-slot="column"
            :width="180"
            :centered="true"
          )
            .is-flex
              WtButton.post-button(
                semibold
                :isRouterLink="false"
                :isText="true"
                color="primary"
                :disabled="processing"
                :loading="questionIdBeingProcessed === column.row.id"
                @click.native="toggleQuestionArchivedStatus(column.row)"
              ) Unarchive
              WtButton.post-button(
                semibold
                :isRouterLink="false"
                :isText="true"
                color="grey"
                :disabled="processing"
                :loading="questionIdBeingProcessed === column.row.id"
                @click.native="deleteQuestion(column.row.id)"
              ) Delete
      BTabItem(
        :key="isProTier ? 2 : 1"
        label="Question Library"
      )
        WtEntityTable#questions-table(
          title=''
          has-large-title
          :data="libraryQuestions"
          default-sort-field="question"
          empty-message="No questions found..."
          :showEmptyMessage="true"
          :enableSearch="true"
          :searchFields="['question']"
          searchPlaceholder="Search the question library..."
        )
          BTableColumn(
            field="question"
            label="Question"
            sortable
            v-slot="column"
          )
            .is-flex.is-flex-direction-column
              span {{ column.row.question }}
              QuestionViewAnswers(:type="column.row.type" :answers="column.row.fields" :correctAnswer="column.row.correctAnswer")
          BTableColumn(
            field="active"
            label="Post Question"
            sortable
            v-slot="column"
            :width="180"
            :centered="true"
          )
            WtButton.post-button(
              semibold
              :isRouterLink="false"
              :isText="true"
              :color="!column.row.active ? 'primary' : 'grey'"
              :disabled="processing"
              :loading="questionIdBeingProcessed === column.row.id"
              @click.native="createQuestionWithData(column.row)"
            ) Enable
    BModal(:active.sync="createQuestionModalOpen" has-modal-card)
      .modal-card(style='width: auto')
        header.modal-card-head
          p.modal-card-title {{questionModalTitle}}
          WtIconButton.close-button(@click.native="toggleQuestionModal(false)" aria-label="Close modal")
            BIcon(icon="close-circle" type="is-grey-light" size="is-medium")
        section.modal-card-body.pb-5
          QuestionBuilderAdminSuper(:toggleModal="toggleQuestionModal" :data="questionToEdit" @cancel="createQuestionModalOpen = false" :createQuestionFromData="createQuestionFromData")
    .block(v-if="$auth.user().isWtAdmin")
      ProgramQuestionsAdminSuper
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { dateUtilityMixin } from "@/mixins/dateUtilityMixin";
import WtTile from "@@/WtTile/WtTile";
import WtTitle from "@@/WtTitle/WtTitle";
import WtButton from "@@/WtButton/WtButton";
import WtEntityTable from "@@/WtEntityTable/WtEntityTable";
import QuestionViewAnswers from "./QuestionViewAnswers";
import ProgramQuestionsAdminSuper from "@@/ProgramQuestionsAdminSuper/ProgramQuestionsAdminSuper";
import QuestionBuilderAdminSuper from "@@/ProgramQuestionsAdminSuper/QuestionBuilderAdminSuper";
import WtIconButton from "@@/WtIconButton/WtIconButton";
import QuestionViewAdminSuper from "@@/ProgramQuestionsAdminSuper/QuestionViewAdminSuper";

export default {
  name: "ProgramQuestions",

  components: {
    WtButton,
    WtTitle,
    WtTile,
    WtEntityTable,
    QuestionViewAnswers,
    ProgramQuestionsAdminSuper,
    QuestionBuilderAdminSuper,
    WtIconButton,
    QuestionViewAdminSuper
  },

  mixins: [dateUtilityMixin],

  data() {
    return {
      processing: false,
      removingActiveQuestions: false,
      questionIdBeingProcessed: null,
      activeTab: 0,
      createQuestionModalOpen: false,
      questionToEdit: null,
      createQuestionFromData: false
      // savingLibraryQuestions: false,
      // savingActiveQuestions: false,
      // questionsForUpdateInLibrary: [],
      // questionsForUpdateInActive: []
    };
  },

  computed: {
    ...mapGetters("program", [
      "programQuestions",
      "programQuestionsLoaded",
      "isProTier"
    ]),

    activeAndNotDraftQuestions() {
      return this.programQuestions.filter(q => q.active && !q.draft);
    },

    activeQuestions() {
      return this.activeAndNotDraftQuestions.filter(q => {
        // Wellness challenge questions only appear in the active questions lists if the challenge is active.
        if (q.isWellnessChallenge) {
          return this.activeWellnessQuestions.find(
            activeWellnessQ => activeWellnessQ.id === q.id
          );
        }
        return q;
      });
    },

    activeWellnessQuestions() {
      // an array of all wellness questions that are currently being shown to users in wellness challenges
      return this.activeAndNotDraftQuestions.filter(q => {
        // Wellness challenge questions only appear in the active questions lists if the challenge is active.
        if (q.isWellnessChallenge) {
          return (
            this._.get(q, "challengeStatus", 1) === 1 && // Note: Challenge::Active = 1,  and note that if q.challengeStatus is not set we assume it's active which will allow us to catch the error
            this.moment().isSameOrAfter(
              this.moment(q.startDate).subtract(2, "days") // subtract 2 days to account for the first wellness question which starts a days after the challenge starts.
            ) &&
            this.moment().isSameOrBefore(this.moment(q.endDate))
          );
        }
        return false;
      });
    },

    libraryQuestions() {
      // wellness questions should never show up to be "enabled", they are only enabled when a challenge is created
      return this.programQuestions.filter(
        q => !q.active && !q.isWellnessChallenge && !q.draft && !q.archived
      );
    },

    archivedQuestions() {
      return this.programQuestions.filter(
        q => !q.active && !q.isWellnessChallenge && !q.draft && q.archived
      );
    },

    draftQuestions() {
      return this.programQuestions.filter(
        q => !q.isWellnessChallenge && q.draft
      );
    },

    questionModalTitle() {
      if (this.questionToEdit) {
        return "Edit Question";
      }
      return "Create New Question";
    }
  },

  watch: {
    createQuestionModalOpen() {
      if (this.createQuestionModalOpen === false) {
        this.questionToEdit = null;
        this.createQuestionFromData = false;
      }
    }
  },

  mounted() {
    this.fetchProgramQuestions({ programId: this.$auth.user().programId });
  },

  methods: {
    ...mapActions("program", [
      "fetchProgramQuestions",
      "updateProgramQuestion",
      "activateOrDeactivateProgramQuestion",
      "deactivateAllProgramQuestions",
      "shiftQuestionsOrder",
      "archiveOrUnarchiveProgramQuestion",
      "deleteProgramQuestion"
    ]),
    ...mapActions(["snackBar"]),

    toggleQuestionStatus(question) {
      this.processing = true;
      this.questionIdBeingProcessed = question.id;
      this.activateOrDeactivateProgramQuestion({
        questionId: question.id,
        programId: this.$auth.user().programId,
        active: !question.active
      }).then(() => {
        this.processing = false;
        this.questionIdBeingProcessed = null;
      });
    },

    toggleQuestionArchivedStatus(question) {
      this.processing = true;
      this.questionIdBeingProcessed = question.id;
      this.archiveOrUnarchiveProgramQuestion({
        questionId: question.id,
        programId: this.$auth.user().programId,
        active: !question.active,
        archived: !question.archived ? 1 : 0
      }).then(() => {
        this.processing = false;
        this.questionIdBeingProcessed = null;
      });
    },

    updateQuestionRequired(newValue, question) {
      if (newValue !== question.required) {
        this.processing = true;
        this.updateProgramQuestion({
          questionId: question.id,
          required: newValue
        }).then(() => {
          this.processing = false;
        });
      }
      // PARAMS for the initial logic below: newValue, question, table
      // const updateList =
      //   table === "library"
      //     ? this.questionsForUpdateInLibrary
      //     : this.questionsForUpdateInActive;
      //
      // const index = updateList.findIndex(val => val === question.id);
      //
      // if (index === -1 && newValue !== question.required) {
      //   updateList.push(question.id);
      // } else if (index > -1 && newValue === question.required) {
      //   updateList.splice(index, 1);
      // }
    },

    async removeAllActiveQuestions() {
      this.$buefy.dialog.confirm({
        title: "Remove All Active Questions",
        confirmText: "Confirm",
        type: "is-danger",
        hasIcon: true,
        message:
          "Are you sure you want to remove all Active questions? Members will no longer be able to see or answer these questions. <br><br> Note: Wellness Challenge Questions cannot be removed.",
        onConfirm: async () => {
          this.processing = true;
          this.removingActiveQuestions = true;
          this.deactivateAllProgramQuestions({
            programId: this.$auth.user().programId
          }).then(() => {
            this.processing = false;
            this.removingActiveQuestions = false;
          });
        }
      });
    },

    updateQuestionOrder(question, orderDirection) {
      if (
        (question.order === 1 && orderDirection === -1) ||
        (question.order === this.getHighestOrder() && orderDirection === +1)
      ) {
        return;
      }
      this.processing = true;
      const questionToShiftWith = this.activeQuestions.find(
        q => q.order === question.order + orderDirection
      );

      this.shiftQuestionsOrder({
        questionId: question.id,
        questionIdShiftTo: questionToShiftWith.id
      }).then(() => {
        this.processing = false;
      });
    },

    getHighestOrder() {
      let maxOrder = 0;
      if (this.activeQuestions.length) {
        const allOrders = [...this.activeQuestions.map(q => parseInt(q.order))];
        maxOrder = Math.max.apply(null, allOrders);
      }
      return maxOrder;
    },

    toggleQuestionModal(state) {
      this.createQuestionModalOpen = state;
    },

    deleteQuestion(questionId) {
      this.processing = true;
      this.$buefy.dialog.confirm({
        title: "Delete This Question",
        confirmText: "Delete This Question",
        type: "is-danger",
        hasIcon: true,
        message:
          "Are you sure you want to delete this question? Question responses will also be deleted.",
        onConfirm: async () => {
          await this.deleteProgramQuestion({ questionId });
          this.processing = false;
        },
        onCancel: () => {
          this.processing = false;
        }
      });
    },

    editQuestion(question) {
      this.questionToEdit = question;
      this.createQuestionModalOpen = true;
    },

    createQuestionWithData(question) {
      this.questionToEdit = question;
      this.createQuestionModalOpen = true;
      this.createQuestionFromData = true;
    }

    // async saveQuestions(table) {
    //   this.processing = true;
    //   if (table === "library") {
    //     this.savingLibraryQuestions = true;
    //   } else {
    //     this.savingActiveQuestions = true;
    //   }
    //
    //   const updateList =
    //     table === "library"
    //       ? this.questionsForUpdateInLibrary
    //       : this.questionsForUpdateInActive;
    //
    //   const promises = [];
    //   for (const id of updateList) {
    //     const question = this.programQuestions.find(q => q.id === id);
    //     if (question) {
    //       promises.push(
    //         this.updateProgramQuestion({
    //           programId: this.programId,
    //           questionId: question.id,
    //           required: !question.required,
    //           hideAlert: true
    //         })
    //       );
    //     }
    //   }
    //
    //   await Promise.all(promises);
    //   this.snackBar({
    //     duration: 5000,
    //     type: "is-success",
    //     message: "The updates were applied successfully."
    //   });
    //
    //   this.processing = false;
    //   if (table === "library") {
    //     this.savingLibraryQuestions = false;
    //     this.questionsForUpdateInLibrary = [];
    //   } else {
    //     this.savingActiveQuestions = false;
    //     this.questionsForUpdateInActive = [];
    //   }
    // },
  }
};
</script>

<style lang="sass" scoped>
#program-questions
  .margin-column-field
    +tablet
      margin-top: $size-3
    +mobile
      margin-bottom: $size-5
  .post-button
    +tablet
      margin-top: $size-7
  .remove-all-questions-button
    margin-top: 20px
    +mobile
      width: 100%
      display: flex
      justify-content: center
  .points-tag
      margin-left: 10px
      background-color: $grey
      color: white
      font-family: $family-sans-serif-bold
      /deep/ span
        height: 1rem
</style>
